import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import ResetPasswordReducer, {
    defaultState,
    asyncActions,
} from 'src/ducks/reset-password.duck';

// We need to do this, to be able to get the typings of the Reducer

const useReducer = () => {
    return useReducerHook(ResetPasswordReducer, defaultState, asyncActions);
};

type IResetPasswordContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const ResetPasswordContext = createContext<Partial<IResetPasswordContext>>({
    state: defaultState,
}) as React.Context<IResetPasswordContext>;

interface AppProps {
    children?: React.ReactNode;
}

const ResetPasswordProvider: React.FC<AppProps> = ({ children }) => {
    const reducer = useReducer();
    return (
        <ResetPasswordContext.Provider
            value={{
                ...reducer,
            }}
        >
            {children}
        </ResetPasswordContext.Provider>
    );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useResetPasswordContext: () => IResetPasswordContext = () =>
    useContext(ResetPasswordContext);
export type IUseResetPasswordContext = ReturnType<
    typeof useResetPasswordContext
>;

export { ResetPasswordContext, ResetPasswordProvider };
